/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking a standard 15-minute break during a long work session.`)
};

const es_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomar una pausa estándar de 15 minutos durante una sesión de trabajo larga.`)
};

const de_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine übliche 15-minütige Pause während einer langen Arbeitssession einlegen.`)
};

const nl_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een standaardpauze van 15 minuten nemen tijdens een lange werksessie.`)
};

const fr_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre une pause standard de 15 minutes pendant une longue session de travail.`)
};

const it_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare una pausa standard di 15 minuti durante una lunga sessione di lavoro.`)
};

const pt_br2_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma pausa padrão de 15 minutos durante uma sessão de trabalho longa.`)
};

const pt_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma pausa padrão de 15 minutos durante uma sessão de trabalho longa.`)
};

const ja_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長い作業セッション中に標準的な15分間の休憩を取る。`)
};

const zh_timer_u15m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在长时间工作中进行标准的15分钟休息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u15m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u15m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u15m_use1", locale)
	if (locale === "en") return en_timer_u15m_use1(inputs)
	if (locale === "es") return es_timer_u15m_use1(inputs)
	if (locale === "de") return de_timer_u15m_use1(inputs)
	if (locale === "nl") return nl_timer_u15m_use1(inputs)
	if (locale === "fr") return fr_timer_u15m_use1(inputs)
	if (locale === "it") return it_timer_u15m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u15m_use1(inputs)
	if (locale === "pt") return pt_timer_u15m_use1(inputs)
	if (locale === "ja") return ja_timer_u15m_use1(inputs)
	return zh_timer_u15m_use1(inputs)
};